import api from '@/api/order'
import { errorHandler } from '../exports/error_management'

const commitItems = (data, commit) => {
    console.log('commitItems data', data)
    const orderItems = [...data].map(x => {
        x.deleted = false
        return x
    })
    commit('SET_ORDER_ITEMS', orderItems)
}

const commitItemsResult = (result, commit, note = '') => {
    console.log('commitItemsResult note', note)
    const {
        data: {
            success: { data },
        },
    } = result
    commitItems(data, commit)
}

const state = {
    items: [],
    item: {},
    pagination: null,
    drivers: [],
    warehouses: [],
    customers: [],
    myorders: [],
    orderItems: [],
    orderLoadingState: false,
}

const getters = {}

const mutations = {
    SET_ORDERS(state, payload) {
        console.log('orders----payload', payload)
        state.items = payload
    },
    SET_ORDER(state, order) {
        state.item = order
    },

    SET_PAGINATION(state, pag) {
        state.pagination = pag
    },
    SET_DRIVERS(state, drivers) {
        state.drivers = drivers
    },

    SET_ORDER_ITEMS(state, orderItems) {
        console.log('SET_ORDER_ITEMS', orderItems)
        state.orderItems = [...orderItems]
    },
    SET_ORDER_LOADING_STATE(state, orderLoadingState) {
        state.orderLoadingState = orderLoadingState
    },
}

const actions = {
    /* Checkoff */
    async createCheckoff(context, { id, data }) {
        try {
            await api.createCheckoff(id, data)
            context.dispatch('fetchById', id)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateCheckoff(context, { id, data, order_checkoff_id }) {
        try {
            await api.updateCheckoff(id, order_checkoff_id, data)
            context.dispatch('fetchById', id)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteCheckoff(context, { id, order_checkoff_id }) {
        try {
            await api.deleteCheckoff(id, order_checkoff_id)
            context.dispatch('fetchById', id)
        } catch (err) {
            errorHandler(err)
        }
    },

    //bulk checkoff
    async selectCheckoffOrders(context, checkoff_type_id) {
        try {
            const result = await api.selectCheckoffOrders(checkoff_type_id)
            const orders = result.data.success.data
            context.commit('SET_ORDERS', orders)
        } catch (err) {
            errorHandler(err)
        }
    },

    async bulkCheckoffOrders(context, payload) {
        try {
            const result = await api.bulkCheckoffOrders(payload)
            const orders = result.data.success.data
            context.commit('SET_ORDERS', orders)
        } catch (err) {
            errorHandler(err)
        }
    },

    //checkoff attachment
    async addCheckoffAttachment(context, { id, order_checkoff_id, url }) {
        try {
            const result = await api.addCheckoffAttachment(
                id,
                order_checkoff_id,
                url
            )
            const order = result.data.success.data
            context.commit('SET_ORDER', order)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteCheckoffAttachment(
        context,
        { id, order_checkoff_id, attachment_id }
    ) {
        try {
            const result = await api.deleteCheckoffAttachment(
                id,
                order_checkoff_id,
                attachment_id
            )
            const order = result.data.success.data
            context.commit('SET_ORDER', order)
        } catch (err) {
            errorHandler(err)
        }
    },

    //////////////////////////////////////////////////////////////

    async uploadOrder({ commit, state }, payload) {
        // get the response whether the reqest failed or was successful
        try {
            const result = await api
                .uploadOrder(payload)
                .then(response => response)
                .catch(error => error.response)

            let success = result.data.success
            let { data } = success == undefined ? {} : success
            if (!data) return result.data.success || result.data.error
            console.log('uploadOrder data', data)

            const orders = [...state.items]
            const idx = orders.findIndex(x => x.id === data.id)
            orders.splice(idx === -1 ? orders.length : idx, 1, data)
            commit('SET_ORDERS', orders)

            return result.data.success
        } catch (err) {
            errorHandler(err)
        }
    },
    //////orderItems section
    async fetchOrderItems(context, id) {
        try {
            const result = await api.fetchOrderItems(id)
            commitItemsResult(result, context.commit, 'fetchOrderItems')
        } catch (err) {
            errorHandler(err)
        }
    },

    async createTemplate(context, { id, template }) {
        try {
            const result = await api.createTemplate(id, template)
            return result.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateOrderItems(context, { id, total, items }) {
        try {
            const result = await api.updateOrderItems(id, { total, items })
            commitItemsResult(result, context.commit, 'updateOrderItems')
            const order = { ...context.state.item }
            order.total_price = total
            context.commit('SET_ORDER', order)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateOrderItem(context, { order_id, id, item }) {
        try {
            const result = await api.updateOrderItem(order_id, id, item)
            commitItemsResult(result, context.commit, 'updateOrderItem')
        } catch (err) {
            errorHandler(err)
        }
    },

    async createOrderItem(context, { order_id, item }) {
        try {
            const result = await api.createOrderItem(order_id, item)
            commitItemsResult(result, context.commit, 'createOrderItem')
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteOrderItem(context, { order_id, id }) {
        try {
            const result = await api.deleteOrderItem(order_id, id)
            commitItemsResult(result, context.commit, 'deleteOrderItem')
        } catch (err) {
            errorHandler(err)
        }
    },

    ////////////orderItems section
    myorders() {
        return api
            .myorders()
            .then(result => {
                console.log({ result })
            })
            .catch(err => {
                throw err
            })
    },
    async markAsComplete(context, id) {
        await api.markAsComplete(id)
        context.dispatch('fetchById', id)
    },

    async markAsIncomplete(context, id) {
        await api.markAsIncomplete(id)
        context.dispatch('fetchById', id)
    },

    async create(_, payload) {
        try {
            const res = await api.create(payload)
            return res.data.success.data
        } catch (err) {
            console.log('create err', err)
            errorHandler(err)
        }
    },

    async fetchById({ commit }, id) {
        try {
            commit('SET_ORDER', {})
            if (id > 0) {
                commit('SET_ORDER_LOADING_STATE', true)
                const result = await api.fetchById(id)
                const order = result.data.success.data
                commit('SET_ORDER', order)
            }
        } catch (err) {
            console.log('fetch err', err)
            errorHandler(err)
        } finally {
            commit('SET_ORDER_LOADING_STATE', false)
        }
    },

    async fetch(
        { dispatch, rootState, commit },
        { query, filters, page: page_no }
    ) {
        page_no = parseInt(page_no) || 1
        await dispatch('itemType/fetchAll', {}, { root: true })

        const getTasks = items =>
            items.filter(
                _item =>
                    !!rootState.itemType.items.find(
                        _type => _type.id === _item.order_item_type_id
                    ).is_task
            )
        const result = await api.fetch(query, filters, page_no)
        let {
            data: _orders,
            current_page: page,
            per_page: pageSize,
            total,
        } = result.data.success.data

        let orders = _orders.map(o => {
            const tasks = getTasks(o.items)
            o.totalTasks = tasks.length
            o.completedTasks = tasks.filter(x => x.task_checked).length
            o.taskCompletion =
                o.totalTasks > 0 ? (o.completedTasks / o.totalTasks) * 100 : 0
            o.checked = o.taskCompletion == 100
            return o
        })

        commit('SET_PAGINATION', {
            page,
            pageSize,
            total,
        })

        commit('SET_ORDERS', orders)
    },

    async fetchDirect(_, { query, filters, page: page_no }) {
        page_no = parseInt(page_no) || 1
        const result = await api.fetch(query, filters, page_no)
        let { data } = result.data.success.data
        return data
    },

    async update(context, payload) {
        try {
            const { id } = payload
            delete payload.id
            console.log('update params', { id, payload })
            const resp = await api.update(id, payload)
            console.log('store/order update resp', resp)
            const order = resp.data.success.data
            /////context.dispatch('fetchOrderItems', payload.id)
            console.log('vuex update', order)
            context.commit('SET_ORDER', order)
            //// commitItems(order.items, context.commit)
        } catch (err) {
            errorHandler(err)
        }
    },

    delete({ state, commit }, id) {
        return api
            .delete(id)
            .then(() => {
                const items = [...state.items]
                let index = items.findIndex(x => x.id == id)
                items.splice(index, 1)
                commit('SET_ORDERS', items)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    bulkSetDriver(context, payload) {
        return api
            .bulkSetDriver(payload.orders, payload.driverId)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    bulkSetWarehouse(context, payload) {
        return api
            .bulkSetWarehouse(payload.orders, payload.warehouseId)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },

    bulkRelease(context, payload) {
        return api
            .bulkRelease(payload.orders)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },

    bulkSetIncomplete(context, payload) {
        return api
            .bulkSetIncomplete(payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    bulkDelete(context, payload) {
        return api
            .bulkDelete(payload.orders)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    //////
    fetchDrivers(context) {
        return api.fetchDrivers().then(result => {
            context.commit('SET_DRIVERS', result.data.success.data)
        })
    },

    //
    deleteAttachment(context, { order_id, attachment_id }) {
        return api
            .deleteAttachment(order_id, attachment_id)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    addAttachment(context, payload) {
        try {
            return api
                .addAttachment(payload)
                .then()
                .catch(err => {
                    errorHandler(err)
                })
        } catch (error) {
            console.error(error)
            throw error
        }
    },
    fetchPresigned(context, key) {
        try {
            return api
                .fetchPresigned(key)
                .then(url => {
                    return url
                })
                .catch(err => {
                    errorHandler(err)
                })
        } catch (error) {
            console.error(error)
            throw error
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
